import { CanActivateFn } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { GlobalService } from 'src/app/services/common/global.service';
import { Modules } from 'src/app/models/Modules.enum';

export const co2CanActivateFn: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(GlobalService).isModuleEnabled(Modules.co2);
};
